'use strict';
import { getCalculatingFieldTooltip } from 'App/helpers/formulaText';

angular.module('upResources').service('ParseFormula', [
	function () {
		return getCalculatingFieldTooltip;
	}
]);
